import { Modal, spacing } from '@retailer-platform/shared-components'
import React, { type FunctionComponent, useMemo } from 'react'
import { css } from '@emotion/react'
import { type PartnerPickDeviceDatum } from 'domains/partner-pick-devices/types/partnerPickDevices.types'
import { PartnerPickDevicesForm } from 'domains/partner-pick-devices/components/form/PartnerPickDevicesForm'
import { usePartnerPickDevicesFormData } from 'domains/partner-pick-devices/components/form/utils/usePartnerPickDevicesFormData.hooks'
import { LoadingPage } from 'gin-and-tonic/containers/loading-page/LoadingPage'
import { ErrorPage } from 'gin-and-tonic/containers/error-page/ErrorPage'
import { type WarehouseLocation } from 'legacy/common/types'
interface PartnerPickDevicesModalProps {
  warehouseLocationId: string
  deviceId?: PartnerPickDeviceDatum['id']
  onSave: (savedDevice: PartnerPickDeviceDatum) => void
  onClose: () => void
  warehouseLocations: WarehouseLocation[]
}

const wrapper = css({
  padding: `${spacing.X24}`,
})

export const PartnerPickDevicesModal: FunctionComponent<PartnerPickDevicesModalProps> = ({
  warehouseLocationId,
  deviceId,
  onSave,
  onClose,
  warehouseLocations,
}) => {
  const { formData, formDataLoading, formDataError, refetch } = usePartnerPickDevicesFormData({
    deviceId,
  })

  const ModalContent = useMemo(() => {
    if (formDataLoading) {
      return <LoadingPage />
    }

    if (formDataError) {
      return <ErrorPage action={() => refetch()} />
    }

    if (formData) {
      return (
        <PartnerPickDevicesForm
          formData={formData}
          warehouseLocationId={warehouseLocationId}
          deviceId={deviceId}
          onSave={onSave}
          onCancel={onClose}
          warehouseLocations={warehouseLocations}
        />
      )
    }
  }, [
    formData,
    formDataLoading,
    formDataError,
    refetch,
    deviceId,
    warehouseLocationId,
    onSave,
    onClose,
    warehouseLocations,
  ])

  return (
    <Modal isOpen onRequestClose={onClose} maxHeight={750}>
      <div css={wrapper}>{ModalContent}</div>
    </Modal>
  )
}
